import { Paper, styled } from '@mui/material';
import { ON_SURFACE_VARIANT, OUTLINE_VARIANT } from 'constants/colors';
import { NEW_PRIMARY_LIGHT } from 'constants/colors';

export const StyledStickyPaper = styled(Paper)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  backgroundColor: NEW_PRIMARY_LIGHT,
  zIndex: 40,
  boxShadow: 'none',
  margin: `${theme.spacing(2)} ${theme.spacing(4)}`,
  borderBottom: `1px solid ${OUTLINE_VARIANT}`,
  '& button, a': {
    color: ON_SURFACE_VARIANT
  }
}));
